import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import * as Sentry from '@sentry/ember';

export default class ApplicationRoute extends Route {
  // Services
  @service breadcrumb;
  @service headData;
  @service locale;
  @service msal;
  @service router;
  @service session;

  // Hooks
  async beforeModel() {
    await this.msal.setup();
    await this.session.setup();
    this.locale.setup();
  }

  constructor() {
    super(...arguments);

    this.router.on('routeDidChange', () => {
      const breadcrumbRoute = this.breadcrumb.currentRoute;
      const title = breadcrumbRoute?.name;

      if (!title) {
        return;
      }

      this.headData.title = title;
      this.headData.favicon = breadcrumbRoute.recordType;
    });
  }

  // In native-class routes, Ember only treats methods decorated with @action
  // as route events. The error event that fires when a model hook
  // rejects is one of those. So it needs the @action decoartor.
  @action
  error(error) {
    Sentry.captureException(error);
    return true;
  }
}
